import React from "react";

export default function ProgressBar({ progress }) {
  return (
    
      <div
        className="progress me-5 flex-grow-1 thin"
        role="progressbar"
        aria-label="Success example"
        aria-valuenow={progress}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          className="progress-bar bg-theme-color"
          style={{ width: `${progress}`, background: progress.split("%")[0] < 100 ? "#82BD00" : "#f05203" }}
        ></div>
      </div>
  );
}
